module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-bar"
  }, [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.breadcrumbArray
    }
  })], 1), _vm._v(" "), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Gallery")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.previewMode),
      expression: "!previewMode"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('resource-picker', {
    key: _vm.pickerKey,
    attrs: {
      "noButton": true,
      "showDoneButton": false,
      "imageButton": false,
      "selectOnly": false
    },
    on: {
      "selected": _vm.updateImage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMode),
      expression: "previewMode"
    }],
    staticClass: "row margin-top-20"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.image_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePreview()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tClose\n\t\t\t\t\t")]), _vm._v(" "), (_vm.$root.permissions['gallery delete']) ? _c('button', {
    staticClass: "btn btn-outline blue pull-right margin-right-10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openDeleteModal()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tDelete\n\t\t\t\t\t")]) : _vm._e()])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showDeleteModal,
      "effect": "fade"
    },
    on: {
      "closeOnEscape": _vm.closeDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeDeleteModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Delete Image")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteErrorMessage.length),
      expression: "deleteErrorMessage.length"
    }],
    ref: "deleteErrorMessage",
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.clearDeleteErrorMessage()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.deleteErrorMessage))])]), _vm._v(" "), _c('p', [_vm._v("Are you sure you want to delete this image?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteImage()
      }
    }
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "note note-info"
  }, [_c('p', [_vm._v("Preview and upload images.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87ea66fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Gallery.vue
// module id = 764
// module chunks = 0